module.exports = __webpack_public_path__ + "img/fail1.0a64afb5.gif";